import { gql } from '@apollo/client';

export const GET_MESSAGES = gql`
  query GetMessages($conversationId: ID!) {
    messages(conversationId: $conversationId) {
      id
      content
      createdAt
      sender
      type
      tool
      status
      attachments {
        id
        conversationId
        messageId
        documentId
        projectId
        originalName
        mimeType
        sizeBytes
        status
        createdAt
        updatedAt
      }
      toolCalls {
        id
        messageId
        toolCallId
        toolName
        title
        input
        output
        errorText
        state
        approvalId
        approved
        approvalReason
        createdAt
        updatedAt
      }
      processSteps {
        id
        messageId
        parentId
        chatToolCallId
        type
        status
        title
        summary
        provider
        metadata
        orderIndex
        startedAt
        completedAt
        createdAt
        updatedAt
      }
      feedback {
        id
        type
      }
    }
  }
`;
